import styled from 'styled-components';

import { addWindow, setMobileView } from 'store/slice/pdpStateSlice';
import { IProductSearch } from 'shared/types/ProductSearch';
import { Loader } from 'shared/components/Loader';
import { Update2022VariantGridItem } from 'productTemplate/components/buyBar/Update2022VariantGridItem';
import { useStoreDispatch } from 'store/hooks/storeHooks';
import { useRouter } from 'next/router';
import { useWindowSize } from 'shared/hooks/useWindowSize';

export interface IUpdate2022VariantGridProps {
  className?: string;
  variants: IProductSearch[];
  isLoading?: boolean;
}

export const Update2022VariantGrid = ({
  className,
  variants,
  isLoading,
}: IUpdate2022VariantGridProps) => {
  const storeDispatch = useStoreDispatch();
  const { isMobile } = useWindowSize();
  const router = useRouter();
  const { query, asPath } = router;

  const onGridItemClick = (variant) => {
    if (isMobile) {
      storeDispatch(setMobileView({ view: 'detail', size: variant.size }));

      const queryParams = { ...query };
      queryParams.variantId = variant.id;
      delete queryParams.productTemplateSlug;

      void router.replace({ pathname: asPath.split('?')?.[0], query: queryParams });
    } else {
      storeDispatch(addWindow(variant));
    }
  };

  if (isLoading)
    return (
      <div className={className}>
        <Update2022VariantGrid.Loader />
      </div>
    );

  return (
    <Update2022VariantGrid.Root className={className}>
      {variants.map((variant) => (
        <Update2022VariantGrid.Item
          data-qa="variant_item_link"
          key={variant?.id}
          variant={variant}
          onClick={() => onGridItemClick(variant)}
        />
      ))}
    </Update2022VariantGrid.Root>
  );
};

Update2022VariantGrid.Loader = styled(Loader)`
  margin: 50px auto;
`;

Update2022VariantGrid.Root = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-gap: 16px;

  grid-template-columns: repeat(2, 1fr);

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

Update2022VariantGrid.Item = styled(Update2022VariantGridItem)`
  cursor: pointer;
`;
